// ============================================================
// Sold-out redirect for ANY-condition collections
// Chidori Vintage  |  Muhammad Khuzaima
// ============================================================
// Purpose:
//   ANY-condition collections cannot use Shopify's native
//   "Inventory stock > 0" rule, so sold-out items leak into
//   the listing. This script redirects those collections to
//   their /instock tag view, which Shopify filters server-side
//   BEFORE pagination, keeping pages full and accurate.
//
// Behaviour:
//   /collections/handle              -> /collections/handle/instock
//   /collections/handle/scroll       -> /collections/handle/scroll+instock
//   /collections/handle/instock      -> no change (already filtered)
//   /collections/handle/scroll+instock -> no change (already filtered)
//
//   The "instock" tag is maintained automatically by Shopify Flow.
// ============================================================

(function () {
  // --- The ANY-condition collections that need filtering ---
  var anyCollections = [
    'japanese-sake-cups-and-bottles',
    'japanese-pins-badges',
    'japanese-tea-cup-sets',
    'japanese-lanterns-and-lights',
    'japanese-photos-negatives',
    'japanese-textiles',
    'japanese-statues-figurines-dolls',
    'japanese-tea-cups',
    'japanese-sewing-jewery-boxes',
    'japanese-paintings-prints',
    'japanese-furniture-and-boxes',
    'japanese-wooden-boxes',
    'japanese-tables-and-stands',
    'japanese-flower-arrangement-ikebana',
    'japanese-pots-and-kettles',
    'japanese-scrolls',
    'other-miscellaneous-items',
    'japanese-tea-ceremony-items',
    'japanese-metal-items'
  ];

  // Get the collection handle from the URL, e.g. "japanese-scrolls"
  function getCollectionHandle() {
    var match = window.location.pathname.match(/\/collections\/([^\/]+)/);
    return match ? match[1] : null;
  }

  // Get the tag segment after the handle, e.g. "scroll" or "scroll+instock"
  function getTagSegment() {
    var match = window.location.pathname.match(/\/collections\/[^\/]+\/([^\/]+)/);
    return match ? match[1] : null;
  }

  function doRedirect() {
    // Allow manual bypass for testing: add ?noredirect=1 to any URL
    if (window.location.search.indexOf('noredirect=1') !== -1) return;

    var handle = getCollectionHandle();
    if (!handle) return;

    // Only act on the ANY-condition collections
    if (anyCollections.indexOf(handle) === -1) return;

    var tagSegment = getTagSegment();

    // If "instock" is already one of the active tags, stop (prevents loops)
    if (tagSegment && tagSegment.split('+').indexOf('instock') !== -1) {
      return;
    }

    var query = window.location.search || '';

    if (tagSegment) {
      // A tag is already applied (e.g. "scroll") -> stack instock with "+"
      window.location.replace(
        '/collections/' + handle + '/' + tagSegment + '+instock' + query
      );
    } else {
      // No tag applied -> go straight to the instock view
      window.location.replace(
        '/collections/' + handle + '/instock' + query
      );
    }
  }

  // Fire on full page load
  document.addEventListener('DOMContentLoaded', doRedirect);

  // Fire on Shopify AJAX section rendering (menu navigation, filters)
  document.addEventListener('shopify:section:load', doRedirect);

  // Fire on browser history changes (infinite scroll, pagination)
  window.addEventListener('popstate', doRedirect);

  // Also run immediately in case DOMContentLoaded has already fired
  doRedirect();
})();